import { css } from '@eti/styles';
import { Badge, breakpoints } from '@etg/wings';
import { UPSELL_TYPES } from '../utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const upSellStyles = css`
  display: flex;
  max-width: 65%;
  width: fit-content;

  @media (min-width: ${breakpoints._768}) {
    max-width: none;
  }
`;
const ProductUpSell = ({
  upSell
}) => {
  const {
    content,
    type
  } = upSell;
  const upsellVariantDictionary = {
    [UPSELL_TYPES.PROMOTIONAL]: 'promotional',
    [UPSELL_TYPES.INFOMATION]: 'information',
    [UPSELL_TYPES.INCLUDED]: 'positive'
  };
  return /*#__PURE__*/_jsx(Badge, {
    className: upSellStyles,
    dangerouslySetInnerHTML: {
      __html: content
    },
    variant: upsellVariantDictionary[type !== null && type !== void 0 ? type : UPSELL_TYPES.INFOMATION]
  });
};
export default ProductUpSell;
//# sourceMappingURL=ProductUpSell.js.map